import {store} from "../redux/store";

export const validateTranslations = (validationData,
                                     requiredFields,
                                     onlyMainRequired) => {
    let result = true;
    const errorsTabs = [];
    const errors = {};
    const activeLanguages = store?.getState()?.languages?.activeLanguages;
    const mainLanguage = store?.getState()?.languages?.mainLanguage;
    activeLanguages && activeLanguages.forEach(lg => {
        const trData = validationData?.[lg.code] || {};
        const isMain = lg.code === mainLanguage;
        let translationIsNotEmpty = false;
        const errorFields = [];

        requiredFields.forEach(key => {
            if (!trData[key] || trData[key] === "") {
                errorFields.push(key + lg.code);
            } else {
                translationIsNotEmpty = true;
            }
        });
        if (errorFields.length && (isMain || !onlyMainRequired || translationIsNotEmpty)) {
            errorFields.forEach(field => errors[field] = true);
            errorsTabs.push(lg.code);
            result = false;
        }
    });
    return {
        result,
        errorsTabs,
        errors,
    };
};
